export const SetLocalStorage = async (key: any, data: any) => {
  await localStorage.setItem(key, JSON.stringify(data));
};

export const GetLocalStorage = (key: any) => {
  const savedItem: any = localStorage.getItem(key);
  const jsonData = JSON.parse(savedItem);
  return jsonData;
};
